<template>
  <!-- 추천 검색어 -->
  <div
    class="wrap_search recomm_search_keyword"
  >
    <div class="wrap_tit">
      <p class="tit">추천 검색어</p>
    </div>

    <div class="list recomm_keyword_list">
      <ul v-if="dataRecommendList.length > 0" class="wrap_keyword_btn">
        <li
          v-for="(item, index) in dataRecommendList"
          :key="index"
        >
          <button
            class="keyword_btn"
            @click.stop="onKeywordClick(item.kwrdNm)"
          >
            <span class="txt">{{ item.kwrdNm }}</span>
          </button>
        </li>
      </ul>
      <ul v-else>
        <li class="no_list" >
          <span class="txt">추천 검색어가 없습니다.</span>
        </li>
      </ul>
    </div>
  </div>
  <!-- // 추천 검색어 -->
</template>

<script>

export default {
  name: 'TotalSearchRecommendedKeyword',
  metaInfo () {
    return {
      title: '멀티캠퍼스 :: 통합검색'
    }
  },
  components: {
  },
  props: {
  },
  data () {
    return {
      dataRecommendList: [], // 추천 키워드
      isTyping: false, // 검색어 입력중 여부
      isSearchEnd: false // 검색어 입력 완료, 검색결과 노출시 true
    }
  },
  watch: {
  },
  created () {
    if (this.dataRecommendList.length === 0) {
      this.getRecommend()
    }
  },
  mounted () {
  },
  methods: {
    // 추천 키워드
    getRecommend () {
      const cachedData = JSON.parse(sessionStorage.getItem('recommendCache'))

      if (cachedData) {
        this.dataRecommendList = cachedData
        console.log('세션 스토리지에서 추천 키워드 사용 >>>>>>>', this.dataRecommendList)
      } else {
        this.fetchData('selectSearchTotalKeyword', {}, (data) => {
          // 최대 10개
          if (data.itemList != null && data.itemList.length > 0) {
            let text = data.itemList
            if (text.length > 10) {
              text.splice(10)
            }
            this.dataRecommendList = text
          } else {
            this.dataRecommendList = []
          }
          // 세션 스토리지에 저장
          sessionStorage.setItem('recommendCache', JSON.stringify(this.dataRecommendList))
          console.log('추천 키워드 >>>>>>>', this.dataRecommendList)
        })
      }
    },
    // 키워드 클릭
    onKeywordClick (val) {
      this.$emit('onKeywordClick', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/search/TotalSearchRecommendedKeyword.vue